import React from "react";
import { Link } from "@mui/material";
import PDFIcon from '@mui/icons-material/PictureAsPdf';

const PDF_URL =
"https://5518720.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=586&deploy=1&compid=5518720&ns-at=AAEJ7tMQxVCgFKfgCL6QsUG_M2QozmQK-fGwytT4TEg2wFsv0yQ";

const PDF = ({ entityId, recordId, recordType }) => {

    if (!entityId) {
        return <div>Error - No customer id provided</div>;
    }

  // Opens A NetSuite PDF
  return (
    <Link
      target="_blank"
      underline="none"
      href={`${PDF_URL}&recordType=${recordType}&recordId=${recordId}&entityId=${entityId}`}
    >
      <PDFIcon style={{ color: 'black' }} /> 
    </Link>
  );
};

export default PDF;
